module.exports = __webpack_public_path__ + "img/christmas_tree.10d9c2f8.gif";